import React, { useEffect, useState } from 'react'
import intl from 'react-intl-universal'
import { useAppSelector } from '@/store/hooks'
import dayjs from 'dayjs'
import IconFont from '@/components/IconFont'
import Loading from '@/components/Loading'
import IconButton from '@/components/IconButton'
import Request from '@/utils/request'
import type { globalTypes, userInfoTypes, roomInfoTypes } from '@/store/store.d'
import { Space, Tag, Dropdown } from 'antd'

import styles from './index.module.scss'

type scheduleType = {
  talk: {
    start_at: string,
    end_at: string,
    room_url: string,
  },
  user: {
    name: string,
    name_en: string,
    company_name: string,
  }
}

// 今日洽谈日程
type NegotiateTodayProps = {
  locale?: string,
}
const NegotiateToday:React.FC<NegotiateTodayProps> = (props) => {
  // prefer selector over connect
  const locale = useAppSelector((state: any) => state.global?.locale)
  const [schedules, setSchedules] = useState<scheduleType[] | null>(null)

  const getCchedules = async () => {
    console.log('locale', locale)
    const {status, data} = await Request({
      url: `schedules`,
    })
    try {
      if(status && data){
        setSchedules(data)
      }
    } catch (error) {
      console.log('getCchedules-error', error)
    }
  }
  const visibleChange = (visible: boolean) => {
    if(visible){
      getCchedules()
    } else {
      setSchedules(null)
    }
  }

  const handleMenuClick = (info: any) => {
    // No-op for now; menu items are links/labels only
  }

  const items = !schedules ? [
    { key: 'loading', label: <Loading style={{ display: 'block', margin: '10px auto' }} />, disabled: true }
  ] : (
    !schedules.length ?
      [ { key: 'empty', label: <div style={{textAlign: 'center'}}>{intl.get('no_negotiate_today')}</div> } ] :
      schedules.map((item: scheduleType, index:number) => ({
        key: `id_${index}`,
        label: (
          <div style={{whiteSpace: 'initial'}} className={styles['schedule-item']}>
            <Space className={styles['item__tip']} direction="vertical" size={4}>
              {
                index === 0 &&
                <Tag color="magenta">Next</Tag>
              }
              <span className={styles['item__time']}>{dayjs(item.talk.start_at).format('HH:mm')}-{dayjs(item.talk.end_at).format('HH:mm')}</span>
            </Space>
            <div className={styles['item__info']}>
              <h3 className={styles['user__name']}>{locale === 'en-US' ? (item.user?.name_en || item.user?.name) : item.user?.name}</h3>
              <p className={styles['user__company']}>{item.user?.company_name}</p>
            </div>
          </div>
        )
      }))
  )

  return(
    <>
      <Dropdown
        overlayStyle={{ width: 300 }}
        trigger={["click", "hover"]}
        menu={{ items, onClick: handleMenuClick }}
        onOpenChange={visibleChange}
      >
        <Space>
          <IconButton
            icon={<IconFont type="icon-rili"/>}
            name={intl.get('header.negotiate_today')}/>
        </Space>
      </Dropdown>
    </>
  )
}

export default NegotiateToday
